import React from "react";
import { Input } from "components/Input";
import { Body, Header } from "components/Table/style";
import { Table } from "../../style";

export function PerformanceEnhancer(props) {
  return (
    <Table>
      <Header>
        <tr>
          <th>
            <span></span>
          </th>
          <th>
            <span>Qual Produto?</span>
          </th>
          <th>
            <span>Qual PPM?</span>
          </th>
        </tr>
      </Header>
      <Body>
        <tr>
          <td>Pré</td>
          <td>
            <Input
              type="inputOnly"
              params="health.performanceEnhancer.pre.product"
              item={props.broiler}
              setItem={props.setBroiler}
              placeholder="Digite o Produto"
            />
          </td>

          <td>
            <Input
              type="inputOnly"
              params="health.performanceEnhancer.pre.dose"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
        </tr>
        <tr>
          <td>Inicial</td>
          <td>
            <Input
              type="inputOnly"
              params="health.performanceEnhancer.initial.product"
              item={props.broiler}
              setItem={props.setBroiler}
              placeholder="Digite o Produto"
            />
          </td>

          <td>
            <Input
              type="inputOnly"
              params="health.performanceEnhancer.initial.dose"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
        </tr>
        <tr>
          <td>Crescimento 1</td>
          <td>
            <Input
              type="inputOnly"
              params="health.performanceEnhancer.growth.product"
              item={props.broiler}
              setItem={props.setBroiler}
              placeholder="Digite o Produto"
            />
          </td>

          <td>
            <Input
              type="inputOnly"
              params="health.performanceEnhancer.growth.dose"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
        </tr>
        <tr>
          <td>Crescimento 2</td>
          <td>
            <Input
              type="inputOnly"
              params="health.performanceEnhancer.growth2.product"
              item={props.broiler}
              setItem={props.setBroiler}
              placeholder="Digite o Produto"
            />
          </td>

          <td>
            <Input
              type="inputOnly"
              params="health.performanceEnhancer.growth2.dose"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
        </tr>

        <tr>
          <td>Final</td>
          <td>
            <Input
              type="inputOnly"
              params="health.performanceEnhancer.final.product"
              item={props.broiler}
              setItem={props.setBroiler}
              placeholder="Digite o Produto"
            />
          </td>

          <td>
            <Input
              type="inputOnly"
              params="health.performanceEnhancer.final.dose"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
        </tr>
      </Body>
    </Table>
  );
}
